module.exports = __webpack_public_path__ + "img/aboutTab_bg.9126edfa.png";